<template lang="pug">
	.app
		Tutorial
		MraidSDKTutorial
		MraidSDKTutorialSettings

		PublisherSettingsAI

		CreativeSettings
		CreativeSettingsAI
		CreativeDelete

		CloneCreativeRepository
		CloneTemplateRepository

		VersionDuplicate
		VersionDelete
		VersionSettings

		PlayableCreate
		PlayableCreateFromTemplate
		PlayableCreateFromCocosCreator
		PlayableCreateRequest

		EndCardCreate
		EndCardSelector

		BannerCreateCreative
		BannerCreateVersion

		StoryboardCreateCreative
		StoryboardCreateVersion

		EditablePlayableCreateCreative
		EditablePlayableCreateVersion

		TemplateSettings
		TemplateUpdate
		TemplateCreate

		SizesEdit

		PreviewCreate
		PreviewCreateStoryboard
		PreviewList
		PreviewSettings
		PreviewGenreAdd
		PreviewPortfolio

		EditorElementInfo
		AnimationSettings
		EmitterSettings
		InlineTextEdit
		InlineAssetReplace
		InlineTextReplace

		DownloadDropdown

		UploadAmazonS3
		UploadSkyKids
		UploadMraidio

		MonitoringLog
		ClusterNodes
		ClusterLog
		AssetPreviewMini
		OfferPreviewMini
		CreativePreviewMini

		EditorElementAdd
		EditorElementInfoPropertiesAdd
		EditorElementInfoEffectsAdd
		EditorElementInfoEventsAdd
		EditorElementInfoEventsAddAction

		VersionAssetsAdd

		AssetImageGeneration
		AssetImageGenerationInfo
		AssetImageGenerationEdit
		AssetImageUploadInfo
		AssetImageOriginalInfo
		AssetImageInfo

		AssetVideoGeneration
		AssetVideoGenerationInfo
		AssetVideoGenerationEdit
		AssetVideoUploadInfo
		AssetVideoOriginalInfo
		AssetVideoInfo

		AddUser
		UserAccess
		UserSettingsAI

		AIAgentVoiceTraining

		ProductFeedChooser
		NativeTrackingWarning
		AssetReplaceNotAllowedPopUp

		ItemsDropdown
		InputSelectDropdown
		MultiSelectDropdown
		Confirm
		File
		Documents
		FileViewer

		header.app-header.navbar(v-show="User.loaded && User.currentUser")
			PublisherLogo
			MainMenu
			.online-users(v-if="User.loaded && User.currentUser")
				OnlineUsersHeader
			.right-controls
				TutorialButton
				AccountButton
		.app-body(v-show="User.loaded && User.currentUser")
			.page.preview(v-if="Layout.page === 'playables' || Layout.page === 'banners' || Layout.page === 'end-cards' || Layout.page === 'storyboards' || Layout.page === 'editable-playables' || Layout.page === 'marker'")
				CreativeFilter
				ToolboxPreview
				LayoutWorkspaceToggler
				CreativesPlane
				VersionsPlane
				PreviewZoom
				AIAgent
				main.main(v-if="Creative.loaded && Creative.SelectedCreative && Creative.getOrderedCreativesList(Publisher.SelectedPublisher, Layout.page, Layout.workspace, Layout.creativesFilter).length" :style="{'margin-left': `${Layout.getCreativesPlaneWidth() + Layout.creativesVersionsPlaneWidth}px`}")
					//.container-fluid
					Preview
				SettingsPlane(fixed)
					SettingsContent(v-show="Layout.asideType === 'settings'")
					TestingContent(v-show="Layout.asideType === 'testing'")
				.empty-workspace(v-if="Creative.loaded && !Creative.SelectedCreative && !Creative.getOrderedCreativesList(Publisher.SelectedPublisher, Layout.page, Layout.workspace, Layout.creativesFilter).length")
					span There are no creatives in this workspace
			.page.publisher-list(v-bar v-show="Layout.page === 'publisher-list'" :style="{height: `calc(100vh - ${Layout.headerHeight}px)`}")
				PublisherList
			.page.publisher-contacts(v-bar v-show="Layout.page === 'publisher-contacts'" :style="{height: `calc(100vh - ${Layout.headerHeight}px)`}")
				PublisherContacts
			.page.user-list(v-bar v-show="Layout.page === 'user-list'" :style="{height: `calc(100vh - ${Layout.headerHeight}px)`}")
				UserList
			.page.publisher-settings(v-bar v-show="Layout.page === 'publisher-settings'" :style="{height: `calc(100vh - ${Layout.headerHeight}px)`}")
				PublisherSettings
			.page.publisher-users(v-bar v-show="Layout.page === 'publisher-users'" :style="{height: `calc(100vh - ${Layout.headerHeight}px)`}")
				PublisherUsers
			.page.publisher-invitations(v-bar v-show="Layout.page === 'publisher-invitations'" :style="{height: `calc(100vh - ${Layout.headerHeight}px)`}")
				PublisherInvitations
			.page.publisher-invitations(v-bar v-show="Layout.page === 'user-profile'" :style="{height: `calc(100vh - ${Layout.headerHeight}px)`}")
				UserProfile
			.page.publisher-invitations(v-bar v-show="Layout.page === 'user-actions-log'" :style="{height: `calc(100vh - ${Layout.headerHeight}px)`}")
				UserActionsLog
			.page.publisher-invitations(v-bar v-show="Layout.page === 'monitoring-errors-server'" :style="{height: `calc(100vh - ${Layout.headerHeight}px)`}")
				MonitoringErrorsServer
			.page.publisher-invitations(v-bar v-show="Layout.page === 'monitoring-errors-sql'" :style="{height: `calc(100vh - ${Layout.headerHeight}px)`}")
				MonitoringErrorsSQL
			.page.publisher-invitations(v-bar v-show="Layout.page === 'monitoring-ai-budget'" :style="{height: `calc(100vh - ${Layout.headerHeight}px)`}")
				MonitoringAIBudget
			.page.publisher-invitations(v-bar v-show="Layout.page === 'files-log'" :style="{height: `calc(100vh - ${Layout.headerHeight}px)`}")
				MonitoringFiles
		Auth(v-show="User.loaded && !User.currentUser")
</template>

<script>
	import Screen 									from './../../mixins/screen'

	import ToolboxPreview							from './../../components/Toolbox/ToolboxPreview'
	import Tutorial									from './../../components/Tutorial/Tutorial'
	import MraidSDKTutorial							from './../../components/Testing/MraidSDKTutorial'
	import MraidSDKTutorialSettings					from './../../components/Testing/MraidSDKTutorialSettings'

	import Preview 									from './../../components/Dashboard/Preview'
	import PreviewZoom 								from './../../components/Dashboard/PreviewZoom'
	import CreativeFilter							from './../../components/Creative/CreativeFilter'
	import CreativesPlane 							from './../../components/Creative/CreativesPlane'
	import CreativeDelete							from './../../components/Creative/CreativeDelete'
	import CreativeSettings							from './../../components/Creative/CreativeSettings'
	import CreativeSettingsAI						from './../../components/Creative/CreativeSettingsAI'
	import VersionsPlane 							from './../../components/Version/VersionsPlane'

	import AIAgent									from './../../components/AIAgent/AIAgent'
	import AIAgentVoiceTraining						from './../../components/AIAgent/AIAgent.VoiceTraining'

	import PreviewCreate							from './../../components/Preview/PreviewCreate'
	import PreviewCreateStoryboard					from './../../components/Preview/PreviewCreateStoryboard'
	import PreviewList								from './../../components/Preview/PreviewList'
	import PreviewSettings							from './../../components/Preview/PreviewSettings'
	import PreviewGenreAdd							from './../../components/Preview/PreviewGenreAdd'
	import PreviewPortfolio							from './../../components/Preview/PreviewPortfolio'

	import CloneCreativeRepository					from './../../components/Dashboard/CloneCreativeRepository'
	import CloneTemplateRepository					from './../../components/Dashboard/CloneTemplateRepository'

	import VersionDuplicate 						from './../../components/Version/VersionDuplicate'
	import VersionDelete							from './../../components/Version/VersionDelete'
	import VersionSettings							from './../../components/Version/VersionSettings'

	import PlayableCreate							from './../../components/Playable/PlayableCreate'
	import PlayableCreateFromTemplate				from './../../components/Playable/PlayableCreateFromTemplate'
	import PlayableCreateFromCocosCreator			from './../../components/Playable/PlayableCreateFromCocosCreator'
	import PlayableCreateRequest					from './../../components/Playable/PlayableCreateRequest'

	import EndCardCreate							from './../../components/EndCard/EndCardCreate'
	import EndCardSelector							from './../../components/EndCard/EndCardSelector'

	import AssetReplaceNotAllowedPopUp 				from './../../components/Dashboard/AssetReplaceNotAllowedPopUp'

	import BannerCreateCreative						from './../../components/Banner/BannerCreateCreative'
	import BannerCreateVersion						from './../../components/Banner/BannerCreateVersion'

	import StoryboardCreateCreative					from './../../components/Storyboard/StoryboardCreateCreative'
	import StoryboardCreateVersion					from './../../components/Storyboard/StoryboardCreateVersion'

	import EditablePlayableCreateCreative					from './../../components/EditablePlayable/EditablePlayableCreateCreative'
	import EditablePlayableCreateVersion					from './../../components/EditablePlayable/EditablePlayableCreateVersion'

	import TemplateSettings							from './../../components/Templates/TemplateSettings'
	import TemplateUpdate							from './../../components/Templates/TemplateUpdate'
	import TemplateCreate							from './../../components/Templates/TemplateCreate'

	import SizesEdit								from './../../components/Sizes/SizesEdit'

	import AssetPreviewMini							from './../../components/Dashboard/AssetPreviewMini'
	import OfferPreviewMini							from './../../components/Dashboard/OfferPreviewMini'
	import CreativePreviewMini						from './../../components/Dashboard/CreativePreviewMini'

	import EditorElementAdd							from './../../components/Editor/EditorElementAdd'
	import VersionAssetsAdd							from './../../components/Settings/VersionAssetsAdd'
	import EditorElementInfoPropertiesAdd			from './../../components/Editor/EditorElementInfoPropertiesAdd'
	import EditorElementInfoEffectsAdd				from './../../components/Editor/EditorElementInfoEffectsAdd'
	import EditorElementInfoEventsAdd				from './../../components/Editor/EditorElementInfoEventsAdd'
	import EditorElementInfoEventsAddAction			from './../../components/Editor/EditorElementInfoEventsAddAction'

	import AssetImageGeneration						from './../../components/Asset/AssetImageGeneration'
	import AssetImageGenerationEdit					from './../../components/Asset/AssetImageGenerationEdit'
	import AssetImageGenerationInfo					from './../../components/Asset/AssetImageGenerationInfo'
	import AssetImageUploadInfo						from './../../components/Asset/AssetImageUploadInfo'
	import AssetImageOriginalInfo					from './../../components/Asset/AssetImageOriginalInfo'
	import AssetImageInfo							from './../../components/Asset/AssetImageInfo'

	import AssetVideoGeneration					from './../../components/Asset/AssetVideoGeneration'
	import AssetVideoGenerationEdit				from './../../components/Asset/AssetVideoGenerationEdit'
	import AssetVideoGenerationInfo				from './../../components/Asset/AssetVideoGenerationInfo'
	import AssetVideoUploadInfo					from './../../components/Asset/AssetVideoUploadInfo'
	import AssetVideoOriginalInfo				from './../../components/Asset/AssetVideoOriginalInfo'
	import AssetVideoInfo						from './../../components/Asset/AssetVideoInfo'

	import EditorElementInfo						from './../../components/Editor/EditorElementInfo'
	import InlineTextEdit							from './../../components/Editor/InlineTextEdit'
	import InlineAssetReplace							from './../../components/Editor/InlineAssetReplace'
	import InlineTextReplace							from './../../components/Editor/InlineTextReplace'
	import AnimationSettings						from './../../components/Editor/AnimationSettings'
	import EmitterSettings							from './../../components/Editor/EmitterSettings'

	import InputSelectDropdown						from './../../components/Editor/Controls/InputSelectDropdown'
	import MultiSelectDropdown						from './../../components/Editor/Controls/MultiSelectDropdown'

	import DownloadDropdown							from './../../components/Header/DownloadDropdown'

	import UploadAmazonS3							from './../../components/Dashboard/UploadAmazonS3'
	import UploadSkyKids							from './../../components/Dashboard/UploadSkyKids'
	import UploadMraidio							from './../../components/Dashboard/UploadMraidio'
	import FileViewer							from './../../components/File/FileViewer'

	import MonitoringLog							from './../../components/Monitoring/MonitoringLog'
	import MonitoringErrorsServer					from './../../components/Monitoring/MonitoringErrorsServer'
	import MonitoringErrorsSQL						from './../../components/Monitoring/MonitoringErrorsSQL'
	import MonitoringAIBudget						from './../../components/Monitoring/MonitoringAIBudget'
	import MonitoringFiles							from './../../components/Monitoring/MonitoringFiles'
	import ClusterNodes								from './../../components/Monitoring/ClusterNodes'
	import ClusterLog											from './../../components/Monitoring/ClusterLog'

	import File									from './../../components/File/File'
	import Documents										from './../../components/File/Documents'


	import NativeTrackingWarning 					from '../NativeTracking/NativeTrackingWarning.vue'

	import SettingsPlane 							from './../../components/Settings/SettingsPlane'
	import SettingsContent 							from './../../components/Settings/SettingsContent'
	import TestingContent 							from './../../components/Testing/TestingContent'
	import ProductFeedChooser						from './../../components/Settings/CustomControls/ProductFeedChooser'

	import MainMenu  								from './../../components/Header/MainMenu'
	import TutorialButton 							from './../../components/Header/TutorialButton'
	import LayoutWorkspaceToggler					from './../../components/Header/LayoutWorkspaceToggler'
	import OnlineUsersHeader						from './../../components/Header/OnlineUsersHeader'

	import PublisherLogo 							from './../../components/Publisher/PublisherLogo'
	import PublisherList 							from './../../components/Publisher/PublisherList'
	import PublisherContacts						from './../../components/Publisher/PublisherContacts'
	import PublisherSettings						from './../../components/Publisher/PublisherSettings'
	import PublisherSettingsAI						from './../../components/Publisher/PublisherSettingsAI'
	import PublisherUsers 							from './../../components/Publisher/PublisherUsers'
	import PublisherInvitations 					from './../../components/Publisher/PublisherInvitations'

	import AccountButton 							from './../../components/User/AccountButton'
	import Auth 									from './../../components/User/Auth'
	import UserList 								from './../../components/User/UserList'
	import UserProfile								from './../../components/User/UserProfile'
	import UserSettingsAI							from './../../components/User/UserSettingsAI'
	import AddUser									from './../../components/User/AddUser'
	import UserActionsLog							from './../../components/User/UserActionsLog'
	import UserAccess								from './../../components/User/UserAccess'

	import ItemsDropdown							from './../../components/UI/ItemsDropdown'
	import Confirm									from './../../components/UI/Confirm'

	import { User } 								from './../../services/User'
	import { Publisher } 							from './../../services/Publisher'
	import { Creative } 								from './../../services/Creative'
	import { Layout } 								from './../../services/Layout'

	export default {
		name: 'Dashboard',
		mixins: [Screen],
		screen: {
			updateOn: ["Layout Workspace Changed", "Layout Page Changed", "Current User Changed", "Current User Loaded", "Selected Creative Fully Loaded", "Selected Creative Changed", "Selected Publisher Changed", "Publisher Creatives Loaded", "Aside Type Changed"],
			events: {
				"Layout Page Changed": function() {

					this.$nextTick(() => {

						Broadcast.call("Layout Page Changed Next Tick");

					});

				}
			}
		},
		components: {
			Tutorial,
			MraidSDKTutorial,
			MraidSDKTutorialSettings,

			ToolboxPreview,
			MainMenu,

			PublisherLogo,
			PublisherList,
			PublisherContacts,
			PublisherSettings,
			PublisherSettingsAI,
			PublisherUsers,
			PublisherInvitations,

			TutorialButton,

			CreativeFilter,
			CreativesPlane,
			CreativeDelete,
			CreativeSettings,
			CreativeSettingsAI,

			VersionsPlane,

			AIAgent,
			AIAgentVoiceTraining,

			CloneCreativeRepository,
			CloneTemplateRepository,

			VersionDuplicate,
			VersionDelete,
			VersionSettings,

			PlayableCreate,
			PlayableCreateFromTemplate,
			PlayableCreateFromCocosCreator,
			PlayableCreateRequest,

			EndCardCreate,
			EndCardSelector,

			BannerCreateCreative,
			BannerCreateVersion,

			StoryboardCreateCreative,
			StoryboardCreateVersion,

			EditablePlayableCreateCreative,
			EditablePlayableCreateVersion,

			TemplateSettings,
			TemplateUpdate,
			TemplateCreate,

			SizesEdit,

			PreviewCreate,
			PreviewCreateStoryboard,
			PreviewList,
			PreviewSettings,
			PreviewGenreAdd,
			PreviewPortfolio,

			AssetPreviewMini,
			OfferPreviewMini,
			CreativePreviewMini,

			EditorElementInfo,
			InlineTextEdit,
			InlineAssetReplace,
			InlineTextReplace,
			AnimationSettings,
			EmitterSettings,

			DownloadDropdown,

			UploadAmazonS3,
			UploadSkyKids,
			UploadMraidio,
			FileViewer,

			MonitoringLog,
			MonitoringErrorsServer,
			MonitoringErrorsSQL,
			MonitoringAIBudget,
			MonitoringFiles,
			ClusterNodes,
			ClusterLog,
			File,
			Documents,

			Preview,
			PreviewZoom,
			LayoutWorkspaceToggler,
			SettingsPlane,
			SettingsContent,
			TestingContent,
			OnlineUsersHeader,

			EditorElementAdd,
			VersionAssetsAdd,
			EditorElementInfoPropertiesAdd,
			EditorElementInfoEffectsAdd,
			EditorElementInfoEventsAdd,
			EditorElementInfoEventsAddAction,

			AssetImageGeneration,
			AssetImageGenerationInfo,
			AssetImageGenerationEdit,
			AssetImageUploadInfo,
			AssetImageOriginalInfo,
			AssetImageInfo,

			AssetVideoGeneration,
			AssetVideoGenerationInfo,
			AssetVideoGenerationEdit,
			AssetVideoUploadInfo,
			AssetVideoOriginalInfo,
			AssetVideoInfo,

			AccountButton,
			Auth,
			UserList,
			UserProfile,
			UserSettingsAI,
			AddUser,
			UserActionsLog,
			UserAccess,

			ProductFeedChooser,
			NativeTrackingWarning,
			AssetReplaceNotAllowedPopUp,

			ItemsDropdown,
			InputSelectDropdown,
			MultiSelectDropdown,
			Confirm
		},
		data() {

			this.User = User;
			this.Creative = Creative;
			this.Publisher = Publisher;
			this.Layout = Layout;

			return {
				showed: true
			};
		},
		methods: {
			collectData() {


			}
		}
	}
</script>

<style lang="sass">

	.app

		.app-body
			margin-top: 0

			.page
				position: relative
				width: 100%

				&.preview
					overflow: hidden

			.main
				position: relative
				overflow: hidden
				margin-top: 45px
				height: 100%

				.container-fluid
					padding-top: 30px

			.empty-workspace
				position: absolute
				width: 100%
				height: calc(100% - 55px)
				left: 0
				top: 55px
				display: flex
				align-items: center
				justify-content: center

				span
					font-size: 15px
					color: #9da5b1

		header.app-header.navbar
			position: relative
			flex-direction: row
			flex-wrap: nowrap
			justify-content: space-between
			height: 55px
			padding: 0
			margin: 0
			background-color: #3a4149
			border-bottom: 1px solid #23282c
			flex: 0 0 55px

			.navbar-brand
				position: static
				top: auto
				left: auto
				margin-left: 0

			.download-button
				margin-left: auto

			.settings-button
				margin-left: 0

			.left-controls
				display: flex

			.right-controls
				display: flex
				margin-left: auto

			.demo-access
				display: flex
				color: #f86c6b

		.form-control
			color: rgba(255, 255, 255, 0.87)
			background-color: rgba(255, 255, 255, 0.05)
			border-color: rgba(255, 255, 255, 0.09)

			option
				background-color: #34353e

			&:focus
				color: rgba(255, 255, 255, 0.87)
				background-color: rgba(255, 255, 255, 0.05)
				border-color: rgba(255, 255, 255, 0.09)

				option
					background-color: #34353e

		.switch-slider
			background-color: #343b41
			border: 1px solid #23282c

		.custom-select
			cursor: pointer
			color: #fff
			background: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3e%3cpath fill='%23ffffff' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e") no-repeat right 0.75rem center/8px 10px
			background-color: #343b41
			border: 1px solid #23282c

			&.selected
				background-color: #4dbd74

	html:not([dir="rtl"]) .aside-menu-show.aside-menu-fixed .main,
	html:not([dir="rtl"]) .aside-menu-show.aside-menu-fixed .app-footer
		margin-right: 390px !important

	html:not([dir="rtl"]) .aside-menu-show.aside-menu-fixed.sub-aside-menu-show .main,
	html:not([dir="rtl"]) .aside-menu-show.aside-menu-fixed.sub-aside-menu-show .app-footer
		margin-right: 780px !important

</style>
